export default __webpack_public_path__ + "static/media/ecommerce_development_2023.e2856686.png";